import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	refinementOptionAllStandardIssues: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-standard-issues',
		defaultMessage: 'All standard issue types',
		description: 'Standard issue type option in issue navigator refinement dropdown.',
	},
	refinementOptionAllSubTaskIssues: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-sub-task-issues',
		defaultMessage: 'All sub-task issue types',
		description: 'Sub-task issue type option in issue navigator refinement dropdown.',
	},
	refinementSubtitleStandardIssueTypes: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-standard-issue-types',
		defaultMessage: 'Standard issue types',
		description: 'Standard issue subtitle in issue navigator refinement dropdown.',
	},
	refinementSubtitleSubTaskIssueTypes: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-sub-task-issue-types',
		defaultMessage: 'Sub-task issue types',
		description: 'Sub-task issue subtitle in issue navigator refinement dropdown.',
	},
	refinementOptionAllStandardIssuesIssueTermRefresh: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-standard-issues-issue-term-refresh',
		defaultMessage: 'All standard work types',
		description: 'Standard issue type option in issue navigator refinement dropdown.',
	},
	refinementOptionAllSubTaskIssuesIssueTermRefresh: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-sub-task-issues-issue-term-refresh',
		defaultMessage: 'All sub-tasks',
		description: 'Sub-task issue type option in issue navigator refinement dropdown.',
	},
	refinementSubtitleStandardIssueTypesIssueTermRefresh: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-standard-issue-types-issue-term-refresh',
		defaultMessage: 'Standard work types',
		description: 'Standard issue subtitle in issue navigator refinement dropdown.',
	},
	refinementSubtitleSubTaskIssueTypesIssueTermRefresh: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-sub-task-issue-types-issue-term-refresh',
		defaultMessage: 'Subtasks',
		description: 'Sub-task issue subtitle in issue navigator refinement dropdown.',
	},
});
